import { Input } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useMissingCustomerDetailsForm } from '../../../../../../contexts/missingCustomerDetailsFormContext'

export const CustomerFirstName = (): ReactElement => {
  const { t } = useTranslation()
  const {
    missingCustomerDetailsForm: { FormItem },
  } = useMissingCustomerDetailsForm()

  return (
    <FormItem
      label={t('external_invoices.missing_customer_compliance_details.modal.form.field.first_name.label')}
      name="firstName"
      render={({ field }) => <Input {...field} size="sm" />}
    />
  )
}
